import { type ReactNode, lazy, Suspense } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../../shared/hooks/useAuth'
import type { WorkKind } from './scopedWork'

const groupsWorkPath = (kind: WorkKind) => kind === 'new_joiners' ? '/groups/new-joiners' : '/groups/continuation-options'
const AdviserWorkspace = lazy(() => import('./AdviserWorkspace').then(module => ({ default: module.AdviserWorkspace })))

// Ali can enter only these two Groups paths. Never mount the unrestricted
// Groups application for a restricted account, even for a forged deep link.
export function GroupsAccessRoute({ children }: { children: ReactNode }) {
  const { role } = useAuth()
  const { pathname } = useLocation()
  if (role === 'employee_lab' || role === 'nzrail_accounts') return <>{children}</>
  if (role !== 'ali') return <Navigate to="/unauthorized" replace />
  const path = pathname.replace(/\/+$/, '')
  const kind = path === groupsWorkPath('new_joiners') ? 'new_joiners'
    : path === groupsWorkPath('continuations') ? 'continuations' : null
  if (!kind) return <Navigate to="/unauthorized" replace />
  return <Suspense fallback={<p role="status" className="p-6">Loading client work…</p>}>
    <AdviserWorkspace key={kind} initialKind={kind} useGroupsRoutes />
  </Suspense>
}
